import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AnimatedCounterDirective } from '@app/shared/directives/animated-counter.directive';

@Component({
  selector: 'app-our-numbers',
  templateUrl: './our-numbers.component.html',
  styleUrls: ['./our-numbers.component.scss'],
  imports: [CommonModule, TranslatePipe, AnimatedCounterDirective],
})
export class OurNumbersComponent {
  numbers = [
    {
      heading: 'our-numbers.number-1.heading',
      value: 'our-numbers.number-1.value',
      template: 'our-numbers.number-1.template',
    },
    {
      heading: 'our-numbers.number-2.heading',
      value: 'our-numbers.number-2.value',
      template: 'our-numbers.number-2.template',
    },
    {
      heading: 'our-numbers.number-3.heading',
      value: 'our-numbers.number-3.value',
      template: 'our-numbers.number-3.template',
    },
  ];
}
